import React from "react";
import styles from "./ErrorMsg.module.css";

export default function ErrorMsg({
  showReload = false,
  message = "Something went wrong.",
}) {
  return (
    <div className={styles.errorBox}>
      <p>{message}</p>
      {showReload && (
        <button onClick={() => window.location.reload()}>Retry</button>
      )}
    </div>
  );
}
